// Misc
import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

// Styles
const styles = theme => ({
  root: {
    marginRight: -theme.spacing.unit * 2,
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'baseline',
  },
  text: {
    marginRight: theme.spacing.unit * 2,
  },
})

const Heading = ({ primary, secondary, primaryProps, secondaryProps, classes }) => (
  <div className={classes.root}>
    { !!primary && (
      <Typography variant="h5" {...primaryProps} className={classes.text}>
        { primary }
      </Typography>
    ) }
    { !!secondary && (
      <Typography color="textSecondary" {...secondaryProps} className={classes.text}>
        { secondary }
      </Typography>
    ) }
  </div>
)

Heading.propTypes = {
  primary: PropTypes.any,
  primaryProps: PropTypes.any,
  secondary: PropTypes.any,
  secondaryProps: PropTypes.any,
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(Heading)
